export const encodeUrl = (url: string): string => {
  return encodeURI(url.replaceAll(" ", "-"));
};

export const decodeUrl = (url: string | undefined): string => {
  if (!url) {
    return "";
  }
  return decodeURI(url).replaceAll("-", " ");
};

export const formatDate = (dateString: string): string => {
  if (!dateString) {
    return "";
  }
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const storage = {
  set(key: string, value: string): void {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get(key: string): string | undefined {
    const stored = localStorage.getItem(key);
    return stored === null ? undefined : JSON.parse(stored);
  },
  remove(key: string): void {
    localStorage.removeItem(key);
  },
};
